import { css } from 'styled-components'

const styles = css`
    display:flex;
    align-items:center;
`

export default styles
    